import * as React from 'react';
export const SvgStatusWarning = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M15.868 13.267l-6.77-11.62a1.15 1.15 0 00-1.1-.67 1.17 1.17 0 00-1.1.69l-6.77 11.59a1.2 1.2 0 001.1 1.72h13.45a1.237 1.237 0 001.306-1.06 1.19 1.19 0 00-.116-.65zm-6.87-.29h-2v-2h2zm0-3h-2v-5h2z', fill: 'var(--iui-color-icon-warning, hsl(33 90% 33%))' })));
};
export default SvgStatusWarning;
